/* ISD homepage stage engine: category pills + ONE U-shaped arc carousel for every pill
   (curated gift boxes, best sellers, new arrivals, categories and special offers alike).

   Data     assets/isd-stage-feed.js (loaded first) owns the tab model and the sources: the pills are server-rendered child
            blocks, their products are fetched ON DEMAND when a pill is opened (per-pill cache, pages appended as the focal
            product nears the end of what is loaded). blocks/isd-commerce-top-stage.liquid writes the geometry settings
            (data-isdst-cfg). Nothing is hard-coded here.
   Arc      the original two-layer engine: OUTER layer = x / y / opacity (spacing hierarchy:
            inner < middle < outer gap, arc y grows with distance), INNER layer = scale. No rotation.
   Ring     visible window V = largest odd number <= min(perPage, item count) (7 / 5 / 3 positions on
            desktop / tablet / phone). The ring holds E = 2m + 5 slots (m = visible half width): V visible positions plus
            two invisible positions on each side, however many products the pill has (100 products cost the same DOM as 8).
            A slot that leaves the window slides further out while it fades, and only an invisible slot that wraps jumps
            (opacity 0 on both ends) and is re-pointed to the product that enters, so nothing ever teleports in view.
            When N < E the invisible slots are clones of real products and are never shown inside the window
            (aria-hidden, pointer-events: none). When the ring would show the same product twice during a step
            (N = V) the leaving copy fades out first and the entering copy fades in late.
            2 items = one focal product (V = 1) that the other one slides in to replace; 1 item = a single
            centred product without arrows.
   Paging   S.items is the list of the pill (grows in place), S.N is how many of them the ring uses. While more pages exist the
            ring wraps over the loaded part; the next page is requested when the focal product is within hi + 4 of the last
            loaded one, and S.N grows only at a moment when no slot of the ring straddles the seam (so nothing pops). If the
            shopper stops while the window is still at the seam, one gentle cross-fade rebuild takes the new products in.
   Purchase a real <form action="/cart/add"> (hidden variant id + quantity); the submit handler calls
            window.ISD.cart.add and opens the cart drawer. On phones the form is ONE module (arrows + live price,
            Kaching offers, add to cart + quantity); the price bubble above the arc is replaced by the module price.
            While a pill loads, the purchase module is inert and its Kaching widget is removed, so the product of the
            previous list can never be added by mistake.
   Kaching  the documented custom placement: ONE <kaching-bundle product-id="..."> inside the same form, mounted
            for the CENTRED product only. It stays empty (data-initialized="skipped") when the product has no
            offer, and the stage looks exactly as before. Kaching merges the chosen offer into the cart request
            itself, so the normal add keeps working; the request carries the widget's own hidden form input
            (properties[__kaching_bundles]), exactly like a native form post, so the bar the shopper sees is the one
            that is merged. While the widget shows, the stage's own quantity and variant selectors are hidden (the
            deal bars choose the quantity).
   Layout   the title and description boxes reserve a fixed height (2 title lines, 3 / 2 description lines) and product pills
            reserve the height of the widest arc, so switching pills never moves the purchase controls or the content below.
   Pills    ONE compact scrolling row on every width (never wrapped): the list is centred while the pills fit and starts at the left
            edge once they do not; edge fades and two small scroll buttons (mouse devices) show only on the side that still has
            pills; the selected pill is centred on every switch; roving tabindex with ArrowLeft / ArrowRight / Home / End; a polite
            live region announces "Rodoma: <category>, <n> produktų" after a switch.
   Editor   all window / document listeners hang on one AbortController and are removed on
            shopify:section:unload or as soon as the stage root is no longer in the document; selecting a pill block in the
            Theme Editor opens that category. */
(function () {
  'use strict';

  var root = document.getElementById('isdst-stage');
  var cfgEl = document.querySelector('script[data-isdst-cfg]');
  var boxEl = document.querySelector('script[data-isdst-boxes]');
  var Feed = window.ISDStageFeed;
  if (!root || !cfgEl || !Feed || root.__isdst) return;
  root.__isdst = true;

  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!C) return;
  var L = C.labels || {};

  // one AbortController for every window / document listener, so a Theme Editor re-render leaves nothing behind
  var ac = typeof AbortController === 'function' ? new AbortController() : null;
  var dead = false;
  function on(target, type, fn, opts) {
    var o = opts ? Object.assign({}, opts) : {};
    if (ac) o.signal = ac.signal;
    target.addEventListener(type, fn, o);
  }
  function alive() {
    if (dead) return false;
    if (!root.isConnected) { teardown(); return false; }
    return true;
  }

  var $ = function (sel) { return root.querySelector(sel); };
  var navWrap = document.querySelector('[data-isdst-tabs-wrap]');
  var nav = document.querySelector('[data-isdst-nav]');
  var pills = nav ? [].slice.call(nav.querySelectorAll('[data-isdst-tab]')) : [];
  if (!pills.length) return;
  var boxes = [];
  try { boxes = JSON.parse(boxEl ? boxEl.textContent : '[]') || []; } catch (e) { boxes = []; }
  var F = Feed.create({ cfg: C, nav: nav, boxes: boxes, pills: pills });
  var M = F.tabs; // the tab models, in pill order
  if (!C.loop) M.forEach(function (t) { t.limit = Math.min(t.limit, 40); }); // without a loop every product has its own slot
  var titleEl = $('[data-title]'), subEl = $('[data-sub]');
  var floor = $('[data-floor]'), track = $('[data-track]'), probe = $('[data-probe]');
  var priceEl = $('[data-price]'), priceFrom = $('[data-price-from]'), priceCmp = $('[data-price-cmp]'), priceNow = $('[data-price-now]');
  var mFrom = $('[data-mprice-from]'), mCmp = $('[data-mprice-cmp]'), mNow = $('[data-mprice-now]');
  var controls = $('[data-controls]'), prevBtn = $('[data-prev]'), nextBtn = $('[data-next]');
  // The purchase form (and everything inside it) is replaced by a pristine copy after an offer widget has run, so these
  // references are re-resolved by bindRefs() and every listener on them is delegated from the permanent controls wrapper.
  var form, idInput, qtyInput, qtyOut, qtyWrap, addBtn, addLabel, varWrap, varSel, kWrap;
  function bindRefs() {
    form = $('[data-form]');
    var f = function (sel) { return form ? form.querySelector(sel) : null; };
    idInput = f('[data-id]'); qtyInput = f('[data-qty-input]'); qtyOut = f('[data-qty-out]'); qtyWrap = f('[data-qty-wrap]');
    addBtn = f('[data-add]'); addLabel = f('[data-add-label]');
    varWrap = f('[data-variant-wrap]'); varSel = f('[data-variant]');
    kWrap = f('[data-kaching]');
  }
  bindRefs();
  var formTpl = form ? form.cloneNode(true) : null; // the untouched form, taken before anything is mounted into it
  var moreWrap = $('[data-more]'), moreLink = $('[data-more-link]');
  var msgEl = $('[data-msg]'), liveEl = $('[data-live]'), emptyEl = $('[data-empty]'), emptyText = $('[data-empty-text]'), retryBtn = $('[data-retry]'), headEl = $('[data-head]');
  if (!floor || !track || !probe) return;

  var mqM = window.matchMedia('(max-width: 749.98px)');
  var mqT = window.matchMedia('(max-width: 1199px)');
  var mqRM = window.matchMedia('(prefers-reduced-motion: reduce)');
  function bp() { return mqM.matches ? 'm' : (mqT.matches ? 't' : 'd'); }
  function reduced() { return mqRM.matches; }
  function mod(a, n) { return ((a % n) + n) % n; }
  function money(c) { return (window.ISD && window.ISD.money) ? window.ISD.money(c) : (Number(c || 0) / 100).toFixed(2) + ' €'; }
  var ta = document.createElement('textarea');
  function decode(s) { ta.innerHTML = String(s == null ? '' : s); return ta.value; }
  function shortText(raw) {
    var s = decode(raw).replace(/\s+/g, ' ').trim();
    if (!s) return '';
    var max = C.descMax || 110;
    var m = s.match(/^(.{20,}?[.!?])(?:\s|$)/);
    if (m && m[1].length <= max + 40) return m[1];
    if (s.length <= max) return s;
    return s.slice(0, max).replace(/\s+\S*$/, '').replace(/[,;:\-–—(]+$/, '') + '…';
  }
  function urlW(u, w) {
    if (!u) return '';
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function sel(el, v) { if (el) el.hidden = !v; }
  var SIZES = '(max-width: 749.98px) 72vw, 440px';
  function srcsetOf(p) { return urlW(p.im, 450) + ' 450w, ' + urlW(p.im, 750) + ' 750w, ' + urlW(p.im, 1000) + ' 1000w'; }

  // ------------------------------------------------------------------ state
  // S.tab: index of the pill whose products are on stage (-1 = none yet, -2 = a failed load is shown); S.want: pill being loaded
  var S = { tab: -1, want: -1, T: null, items: [], N: 0, m: 0, E: 0, lo: 0, hi: 0, active: 0, els: [], kind: 'prod', geo: null, token: 0, dup: false, ground: false, holdUntil: 0, retry: -1 };
  var SC = [1, C.scale[0], C.scale[1], C.scale[2], C.scale[2] * 0.6, 0.2];
  var OP = [1, 0.97, 0.86, 0.66];
  var qty = 1, adding = false, dragMoved = false, swapTimer = null, autoTimer = null, growTimer = null, lastW = window.innerWidth, lastBp = bp();
  var variantIdx = 0;
  var inkV = {}, inkP = {}; // grounding: ink-bottom gap per photo URL (fraction of the photo height) and the measuring promise
  var K = { on: C.kaching !== false && !!kWrap, el: null, token: 0, timer: 0, poll: 0, guard: 0, active: false, skip: {} };

  function prep(p) {
    if (p._sub === undefined) p._sub = shortText(p.d);
    if (p.vs === undefined) p.vs = null;
    return p;
  }

  // ------------------------------------------------------------------ geometry
  function geometry() {
    var b = bp();
    var w = probe.offsetWidth || 300, h = probe.offsetHeight || Math.round(w * 1.2);
    var sp = S.kind === 'prod' ? (b === 'm' ? C.spread.m : C.spread.d) : 1;
    var gi = b === 'm' ? C.gap.m : C.gap.d;
    var vStep = b === 'm' ? C.vstep.m : C.vstep.d;
    var K = S.m + 2, unit = w * sp, xs = [0], ys = [0], i;
    for (i = 1; i <= K; i++) {
      xs[i] = xs[i - 1] + (i === 1 ? gi[0] : (i === 2 ? gi[1] : gi[2])) * unit;
      ys[i] = Math.pow(i, C.curve) * vStep;
    }
    // desktop / tablet: pull the outer positions in so every visible product stays inside the viewport
    if (b !== 'm' && S.m >= 1) {
      var half = floor.clientWidth / 2 - 16;
      var edge = xs[S.m] + SC[Math.min(S.m, 5)] * w * 0.5;
      if (edge > half) {
        var f = Math.max(0.45, half / edge);
        for (i = 1; i <= K; i++) xs[i] *= f;
      }
    }
    return { b: b, w: w, h: h, xs: xs, ys: ys, K: K };
  }
  // Phones, gift boxes only: the tallest PHOTO of the pill (bottom-aligned in its slot, never taller than the slot), so the empty
  // top of the slot does not become a blank band under the description. Product pills keep the full slot height (a tall
  // bottle may arrive with any later page).
  function photoH(g) {
    var r = g.h / g.w, eh = 0;
    for (var i = 0; i < S.items.length; i++) eh = Math.max(eh, g.w * Math.min(r, 1 / (S.items[i].ar || 1)));
    return eh > 0 ? Math.min(g.h, eh) : g.h;
  }
  // The height of the stage floor. Product pills reserve the room of the WIDEST arc (every visible position of the breakpoint),
  // whatever the number of products, so a pill with 2 products and a pill with 80 have the same height: the purchase
  // controls and the content below never move when the shopper switches category. Gift boxes keep their own (3 products).
  function floorHeight(g) {
    var fixed = g.b === 'm' ? C.floorH.m : C.floorH.d;
    if (fixed > 0) return fixed;
    var vStep = g.b === 'm' ? C.vstep.m : C.vstep.d;
    var pad = g.b === 'm' ? g.w * 0.085 : g.h * 0.073, eh = (g.b === 'm' && S.kind === 'box') ? photoH(g) : g.h;
    // distance from the slot centre up to the top of the photo: eh - h/2 (= h/2 when the photo fills the slot)
    var lift = eh - g.h / 2, top = lift;
    var mf = S.kind === 'box' ? S.m : (C.sides[g.b] || 1);
    for (var k = 1; k <= mf; k++) top = Math.max(top, Math.pow(k, C.curve) * vStep + SC[Math.min(k, 5)] * lift);
    top = Math.max(top, lift + pad);
    return Math.round(pad + g.h / 2 + top);
  }

  function place(el, x, dragPx) {
    var g = S.geo, ao = Math.abs(x), a2 = Math.min(ao, g.K), vis = ao <= S.m;
    var sx = (x < 0 ? -1 : 1) * g.xs[a2] + (dragPx || 0);
    el.__x = x;
    el.style.transform = 'translate(-50%,0) translate(' + sx.toFixed(1) + 'px,' + (-g.ys[a2]).toFixed(1) + 'px)';
    el.firstElementChild.style.transform = 'scale(' + SC[Math.min(a2, 5)] + ')';
    el.style.opacity = vis ? String(OP[Math.min(ao, 3)]) : '0';
    el.style.zIndex = String(30 - Math.min(ao, 4) * 3);
    el.style.pointerEvents = vis ? 'auto' : 'none';
    el.setAttribute('aria-hidden', vis && !el.__ghost ? 'false' : 'true');
    // When the ring shows the same product at both ends of a step, the leaving copy fades out in the first
    // third and the entering copy fades in late, so the two never overlap. (transform keeps the full duration.)
    var was = el.__vis;
    el.__vis = vis;
    if (S.dup && was !== undefined && was !== vis && !dragPx) {
      var d = C.dur || 480;
      el.style.transitionDuration = d + 'ms,' + Math.round(d * (vis ? 0.6 : 0.35)) + 'ms';
      el.style.transitionDelay = '0ms,' + (vis ? Math.round(d * 0.35) : 0) + 'ms';
    } else if (was === vis) {
      el.style.transitionDuration = ''; el.style.transitionDelay = '';
    }
  }
  function jump(el, fn) { el.classList.add('is-jump'); fn(); void el.offsetWidth; el.classList.remove('is-jump'); }
  function placeAll(dragPx) { for (var i = 0; i < S.els.length; i++) place(S.els[i], S.els[i].__x, dragPx); }

  // ------------------------------------------------------------------ slots
  function mkEl() {
    var el = document.createElement('div');
    el.className = 'isdst__slot';
    el.setAttribute('role', 'listitem');
    el.innerHTML = '<div class="isdst__in"><span class="isdst__shadow"></span><img class="isdst__img" alt="" decoding="async" draggable="false"></div>';
    return el;
  }
  function fill(el, p, eager, focal) {
    var im = el.querySelector('img');
    prep(p);
    el.__p = p;
    el.setAttribute('aria-label', p.t);
    el.style.setProperty('--ar', String(p.ar || 1));
    el.style.setProperty('--delay', (S.els.length % 5 * 0.32).toFixed(2) + 's');
    im.alt = p.t;
    im.sizes = SIZES;
    im.srcset = srcsetOf(p);
    im.src = urlW(p.im, 750);
    im.loading = eager ? 'eager' : 'lazy';
    try { im.setAttribute('fetchpriority', focal ? 'high' : (eager ? 'auto' : 'low')); } catch (e) { /* attribute not supported */ }
    setInk(el);
    if (S.ground && inkV[p.im] === undefined) measureInk(p.im);
  }
  // ---- grounding. The photos carry 4-19 % empty margin below the product, so without this a product would hover above its
  // contact shadow by a different amount for every photo. The bottom of the ink is measured ONCE per photo (a 120 px canvas
  // copy loaded with CORS from the Shopify CDN, cached by URL; light or transparent pixels count as background) and the CSS
  // moves the photo so that the feet of every product land on the shadow line. If the canvas is unavailable or tainted, or the
  // measurement fails, nothing moves (the present behaviour). Only the photos of the ring and of the next entrants are measured.
  function measureInk(url) {
    if (!url) return Promise.resolve();
    if (inkP[url]) return inkP[url];
    inkP[url] = new Promise(function (resolve) {
      var done = function (v) { if (v != null) { inkV[url] = v; paintInk(url); } resolve(); };
      try {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.decoding = 'async';
        im.onerror = function () { done(null); };
        im.onload = function () {
          var v = null;
          try {
            var w = 120, h = Math.max(1, Math.round(w * im.naturalHeight / Math.max(1, im.naturalWidth)));
            var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
            var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0, w, h);
            var d = cx.getImageData(0, 0, w, h).data, y, x, n, o;
            for (y = h - 1; y >= 0 && v == null; y--) {
              n = 0;
              for (x = 0; x < w; x++) { o = (y * w + x) * 4; if (d[o + 3] >= 10 && (d[o] < 245 || d[o + 1] < 245 || d[o + 2] < 245)) n++; }
              if (n >= 2) v = (h - 1 - y) / h;
            }
          } catch (e) { v = null; }
          done(v);
        };
        im.src = urlW(url, 120);
      } catch (e) { done(null); }
    });
    return inkP[url];
  }
  function setInk(el) {
    var v = S.ground && el.__p ? inkV[el.__p.im] : undefined;
    if (v == null) el.style.removeProperty('--ink'); else el.style.setProperty('--ink', v.toFixed(4));
  }
  function paintInk(url) { S.els.forEach(function (el) { if (el.__p && el.__p.im === url) setInk(el); }); }
  function whenImages(els, ms) {
    var ps = [];
    els.forEach(function (el) {
      if (Math.abs(el.__x) > S.m) return;
      var im = el.querySelector('img');
      if (im && !im.complete) ps.push(new Promise(function (r) { im.addEventListener('load', r, { once: true }); im.addEventListener('error', r, { once: true }); }));
      if (S.ground && el.__p && inkV[el.__p.im] === undefined && inkP[el.__p.im]) ps.push(inkP[el.__p.im]);
    });
    if (!ps.length) return Promise.resolve();
    return Promise.race([Promise.all(ps), new Promise(function (r) { setTimeout(r, ms); })]);
  }
  // Warm up the photos of the products that are about to enter the arc (same srcset / sizes as the slot, so the browser reuses
  // the download) and measure their ink. Two products per call, only while the page is visible.
  var warmed = {};
  function warm() {
    if (!S.N || document.hidden) return;
    var n = 0;
    for (var k = S.m + 1; k <= S.m + 5 && n < 3; k++) {
      [S.active + k, S.active - k].forEach(function (ix) {
        var p = S.items[mod(ix, S.N)];
        if (!p || warmed[p.im] || n >= 3) return;
        warmed[p.im] = 1; n++;
        var im = new Image();
        im.decoding = 'async'; im.sizes = SIZES; im.srcset = srcsetOf(p); im.src = urlW(p.im, 750);
        if (S.ground && inkV[p.im] === undefined) measureInk(p.im);
      });
    }
  }

  // ------------------------------------------------------------------ build a pill
  function build(T, startIdx) {
    var items = T.out, N = items.length, b = bp();
    S.tab = T.i; S.T = T; S.kind = T.src === 'boxes' ? 'box' : 'prod'; S.items = items; S.N = N;
    S.ground = S.kind === 'prod' && /^100%$/.test((getComputedStyle(root).getPropertyValue('--st-align') || '').trim());
    root.setAttribute('data-kind', S.kind);
    track.innerHTML = ''; S.els = [];
    kClear();
    var empty = N === 0;
    if (headEl) headEl.hidden = empty;
    floor.hidden = empty;
    if (controls) controls.hidden = empty;
    if (emptyEl) {
      emptyEl.hidden = !empty;
      if (empty) { if (emptyText) emptyText.textContent = L.empty || ''; if (retryBtn) retryBtn.hidden = true; }
    }
    root.classList.toggle('is-empty', empty);
    if (empty) { setLive(''); return; }

    var sides = C.sides[b] || 1;
    S.m = N >= 3 ? Math.min(sides, Math.floor((N - 1) / 2)) : 0;
    var loop = C.loop && N > 1;
    S.E = loop ? 2 * S.m + 5 : N;
    S.dup = loop && N === 2 * S.m + 1;
    S.lo = loop ? -Math.floor(S.E / 2) : 0;
    S.hi = loop ? Math.ceil(S.E / 2) - 1 : N - 1;
    S.active = startIdx ? mod(startIdx, N) : 0;
    S.geo = geometry();
    for (var e = 0; e < S.E; e++) {
      var el = mkEl(), x = loop ? S.lo + e : e - S.active;
      S.els.push(el);
      var pi = loop ? mod(S.active + x, N) : e;
      el.__ghost = false;
      el.__x = x;
      fill(el, items[pi], Math.abs(x) <= S.m, x === 0);
      track.appendChild(el);
    }
    refreshGhosts();
    placeAll(0);
    applyFloor();
    reserveText();
    updateUI(true);
    if (prevBtn) prevBtn.hidden = N < 2;
    if (nextBtn) nextBtn.hidden = N < 2;
    floor.classList.toggle('no-swipe', !C.swipe || N < 2);
    restartAuto();
    afterMove();
  }
  function applyFloor() {
    var h = floorHeight(S.geo);
    floor.style.setProperty('--floor-h', h + 'px');
  }

  // the ring slots that are clones: only those that are NOT the real element of their product inside the ring
  function refreshGhosts() {
    if (S.E === S.N) { S.els.forEach(function (el) { el.__ghost = false; }); return; }
    var seen = {};
    // the slot closest to the centre owns the product, the others are ghosts
    var order = S.els.slice().sort(function (a, b) { return Math.abs(a.__x) - Math.abs(b.__x); });
    order.forEach(function (el) {
      var k = el.__p.i;
      el.__ghost = !!seen[k];
      seen[k] = true;
    });
  }

  // ------------------------------------------------------------------ paging: grow the ring while the shopper browses
  // the ring maps slot x to product (active + x) mod N; N may only change while no slot of the ring wraps across the seam
  function seamless() {
    if (!C.loop) return true;
    return S.N >= S.E && S.active + S.lo >= 0 && S.active + S.hi <= S.N - 1;
  }
  function tryGrow() {
    var T = S.T;
    if (!T || dead || T.out.length <= S.N || S.want >= 0) return;
    clearTimeout(growTimer);
    if (seamless()) {
      S.N = T.out.length;
      refreshGhosts();
      return;
    }
    // the window sits on the seam: take the new products in with one gentle rebuild when the shopper stops
    growTimer = setTimeout(softRebuild, 900);
  }
  function softRebuild() {
    var T = S.T;
    if (dead || !T || T.out.length <= S.N || S.want >= 0 || drag) return;
    if (seamless()) { tryGrow(); return; }
    var token = ++S.token;
    track.classList.add('is-out');
    setTimeout(function () {
      if (token !== S.token || dead) return;
      track.classList.add('is-build');
      build(T, S.active);
      whenImages(S.els, 900).then(function () {
        if (token !== S.token || dead) return;
        void track.offsetWidth;
        track.classList.remove('is-build'); track.classList.remove('is-out');
      });
    }, 190);
  }
  // request the next page when the focal product is close to the end of what is loaded
  function ensureAhead() {
    var T = S.T;
    if (!T || dead || T.done || T.p || !C.loop || S.want >= 0 || Date.now() < S.holdUntil) return;
    if (T.out.length - 1 - S.active > S.hi + 4) return;
    F.more(T, false).then(function () { tryGrow(); ensureAhead(); }, function () { S.holdUntil = Date.now() + 8000; });
  }
  function afterMove() { tryGrow(); ensureAhead(); warm(); }

  // ------------------------------------------------------------------ text, price, purchase
  // The title and description boxes reserve a FIXED height (title: 2 lines, description: the line clamp of the CSS), so switching
  // pills never moves the content below the stage, whatever the products are called.
  var szKey = '';
  function reserveText(force) {
    if (!titleEl || !subEl || !headEl || !headEl.offsetWidth) return;
    var key = bp() + ':' + headEl.offsetWidth + ':' + (document.fonts && document.fonts.status ? document.fonts.status : '');
    if (!force && key === szKey) return;
    var tl = parseFloat(getComputedStyle(titleEl).lineHeight) || 0, sl = parseFloat(getComputedStyle(subEl).lineHeight) || 0;
    var lc = parseInt(getComputedStyle(subEl).webkitLineClamp, 10) || 3;
    if (tl) root.style.setProperty('--t-h', Math.ceil(tl * 2) + 'px');
    if (sl) root.style.setProperty('--d-h', Math.ceil(sl * lc) + 'px');
    szKey = key;
  }
  function setLive(t) { if (liveEl) liveEl.textContent = t; }
  // 1 produktas, 2-9 produktai, 0 / 10-19 produktų (Lithuanian); product / products (English)
  function unitOf(n) {
    var u = L.units || [], m10 = n % 10, m100 = n % 100;
    if (u.length < 3) return u[0] || '';
    if (L.unitsLt === false) return n === 1 ? u[0] : u[2];
    return (m10 === 1 && m100 !== 11) ? u[0] : ((m10 === 0 || (m100 >= 11 && m100 <= 19)) ? u[2] : u[1]);
  }
  // after a switch: "Rodoma: Naujienos, 12 produktų. Rodoma: <product>, <price>" (one update; "24+" while more pages are still to come)
  function announceTab(T) {
    if (!liveEl || !L.liveTab) return;
    var n = T.out.length, name = T.mode === 'curated' && T.alt ? T.alt : T.label;
    var msg = L.liveTab.replace('%label%', name).replace('%n%', T.done ? String(n) : n + '+').replace('%u%', unitOf(n));
    liveEl.textContent = msg + '. ' + liveEl.textContent;
  }
  function cur() { return S.N ? S.items[mod(S.active, S.N)] : null; }
  function focalVars(p) {
    var g = S.geo, ratio = g.h / g.w, ar = p.ar || 1;
    root.style.setProperty('--img-w', (g.w * Math.min(1, ar * ratio)).toFixed(1) + 'px');
    root.style.setProperty('--img-h', (g.w * Math.min(ratio, 1 / ar)).toFixed(1) + 'px');
  }
  function curVariant(p) { return p.vs && p.vs.length ? p.vs[Math.max(0, Math.min(p.vs.length - 1, variantIdx))] : null; }
  function paintPrice(p) {
    var v = curVariant(p);
    var price = v ? v.p : p.p, cmp = v ? v.c : p.c;
    var cmpTxt = cmp > price ? money(cmp) : '';
    if (priceCmp) priceCmp.textContent = cmpTxt;
    if (priceNow) priceNow.textContent = money(price);
    if (priceFrom) priceFrom.hidden = !(p.f && !v);
    if (mCmp) mCmp.textContent = cmpTxt;
    if (mNow) mNow.textContent = money(price);
    if (mFrom) mFrom.hidden = !(p.f && !v);
    if (priceEl) priceEl.classList.add('is-visible');
  }
  function paintBuy(p) {
    var v = curVariant(p), avail = v ? v.a : p.a, vid = v ? v.id : p.v;
    var mode = C.cta === 'product' ? 'product' : 'add';
    if (idInput) idInput.value = String(vid || '');
    if (form) { form.dataset.productId = String(p.i); form.dataset.productHandle = p.h; form.dataset.variantId = String(vid || ''); }
    if (addBtn) {
      addBtn.classList.remove('is-added', 'is-error', 'is-loading');
      addBtn.removeAttribute('aria-busy');
      if (!avail) { addLabel.textContent = L.soldout; addBtn.disabled = true; addBtn.classList.add('is-disabled'); }
      else { addBtn.disabled = false; addBtn.classList.remove('is-disabled'); addLabel.textContent = mode === 'product' ? L.choose : L.add; }
    }
    syncQty();
  }
  // the stage's own quantity stepper shows only for an available product, in "add" mode, without a Kaching widget
  function syncQty() {
    var p = cur();
    if (!p) return;
    var v = curVariant(p), avail = v ? v.a : p.a;
    sel(qtyWrap, avail && C.cta !== 'product' && !K.active);
  }

  // ------------------------------------------------------------------ Kaching Bundles (official custom placement)
  function kState(on) {
    if (K.active === on) return;
    K.active = on;
    root.classList.toggle('has-kaching', on);
    if (on) setQty(1);
    syncQty();
  }
  // A widget that ran has hooked click listeners onto the add button (window capture listener + button listener) and
  // observers onto the form. Removing only the widget does not release them, and its own "button was removed" observer
  // would even re-hook them onto the first button it can find. So once a widget has run, the WHOLE form (widget, add
  // button, quantity buttons, hidden inputs the widget wrote) is swapped for a pristine copy: everything the widget
  // touched leaves the document together with the old form and nothing can reach the new controls.
  function freshForm() {
    if (!form || !formTpl || !form.parentNode) return;
    var old = form, act = document.activeElement, key = null;
    if (act && old.contains(act)) {
      ['data-add', 'data-qty-down', 'data-qty-up', 'data-variant'].forEach(function (a) { if (!key && act.hasAttribute && act.hasAttribute(a)) key = a; });
    }
    var nf = formTpl.cloneNode(true);
    old.parentNode.replaceChild(nf, old);
    bindRefs();
    var p = cur();
    if (p) { paintVariants(p, true); paintBuy(p); setQty(qty); }
    if (key) { var t = form.querySelector('[' + key + ']'); if (t && !t.disabled) t.focus({ preventScroll: true }); }
  }
  function kClear() {
    clearTimeout(K.timer); clearTimeout(K.guard); clearInterval(K.poll);
    // 'skipped' = the app found no offer and never hooked anything; any other state may have been hooked already
    var hooked = !!K.el && K.el.getAttribute('data-initialized') !== 'skipped';
    if (hooked) freshForm();
    else if (K.el && K.el.parentNode) K.el.parentNode.removeChild(K.el);
    K.el = null;
    kState(false);
  }
  function kMount(p) {
    kClear();
    if (!K.on || !p || C.cta === 'product' || !p.a || K.skip[p.i]) return;
    var tk = ++K.token;
    K.timer = setTimeout(function () {
      if (tk !== K.token || !alive()) return;
      var el = document.createElement('kaching-bundle');
      el.setAttribute('product-id', String(p.i));
      K.el = el;
      kWrap.appendChild(el);
      var look = function () {
        if (tk !== K.token) return;
        var st = el.getAttribute('data-initialized');
        if (st === 'skipped') { K.skip[p.i] = 1; kClear(); }
        else if (st === 'true' && el.offsetHeight > 24) kState(true);
      };
      // the widget sets data-initialized first and fills itself afterwards, so poll until it has a height
      K.poll = setInterval(function () { if (!alive()) return; look(); if (K.active || !K.el) clearInterval(K.poll); }, 200);
      K.guard = setTimeout(function () { if (tk !== K.token) return; look(); if (!K.active) kClear(); }, 9000);
      look();
    }, 280);
  }
  function paintVariants(p, keep) {
    if (!varWrap || !varSel) return;
    if (!p.vs || p.vs.length < 2) { varWrap.hidden = true; varSel.innerHTML = ''; return; }
    var first = 0;
    for (var i = 0; i < p.vs.length; i++) { if (p.vs[i].a) { first = i; break; } }
    variantIdx = keep ? Math.max(0, Math.min(p.vs.length - 1, variantIdx)) : first;
    varSel.innerHTML = '';
    p.vs.forEach(function (v, i) {
      var o = document.createElement('option');
      o.value = String(i); o.textContent = v.t + ' — ' + money(v.p) + (v.a ? '' : ' (' + L.soldout + ')');
      if (!v.a) o.disabled = true;
      varSel.appendChild(o);
    });
    varSel.value = String(variantIdx);
    varWrap.hidden = false;
  }
  function setQty(n) { qty = Math.max(1, Math.min(20, n)); if (qtyInput) qtyInput.value = String(qty); if (qtyOut) qtyOut.textContent = String(qty); }
  function updateUI(immediate) {
    var p = cur();
    if (!p) return;
    kClear(); // first: swapping the form (after an offer widget ran) must happen before anything is painted into it
    setQty(1);
    variantIdx = 0;
    if (msgEl) msgEl.textContent = '';
    paintVariants(p);
    paintPrice(p);
    kMount(p);
    paintBuy(p);
    focalVars(p);
    if (moreLink) { moreLink.href = p.u; }
    sel(moreWrap, C.showMore !== false);
    var apply = function () {
      if (titleEl) { var a = titleEl.firstElementChild; a.textContent = p.t; a.setAttribute('href', p.u); }
      if (subEl) { subEl.textContent = p._sub || ''; subEl.setAttribute('href', p.u); }
      root.classList.remove('is-swapping');
    };
    clearTimeout(swapTimer);
    if (immediate || reduced()) apply();
    else { root.classList.add('is-swapping'); swapTimer = setTimeout(apply, 140); }
    setLive((L.liveNow || '').replace('%title%', p.t).replace('%price%', money(curVariant(p) ? curVariant(p).p : p.p)));
  }

  // ------------------------------------------------------------------ rotation
  function stepOnce(d) {
    var N = S.N;
    if (N < 2) return;
    if (!C.loop) {
      var na = S.active + d;
      if (na < 0 || na > N - 1) return;
      S.active = na;
      S.els.forEach(function (el) { place(el, el.__x - d, 0); });
      updateUI(false); updateArrows(); restartAuto();
      return;
    }
    S.active = mod(S.active + d, N);
    S.els.forEach(function (el) {
      var nx = el.__x - d, wrapped = false;
      if (nx < S.lo) { nx += S.E; wrapped = true; } else if (nx > S.hi) { nx -= S.E; wrapped = true; }
      if (wrapped) {
        if (S.E !== N) fill(el, S.items[mod(S.active + nx, N)], false, false);
        jump(el, function () { place(el, nx, 0); });
      } else place(el, nx, 0);
    });
    refreshGhosts();
    S.els.forEach(function (el) { el.setAttribute('aria-hidden', Math.abs(el.__x) <= S.m && !el.__ghost ? 'false' : 'true'); });
    updateUI(false);
    updateArrows();
    // make sure the image that is about to enter is loading
    S.els.forEach(function (el) { if (Math.abs(el.__x) <= S.m + 2) { var im = el.querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; } });
    afterMove();
  }
  function stepMany(n, sign) {
    var gap = Math.min(120, Math.round((C.dur || 480) / (n + 1)));
    stepOnce(sign);
    for (var i = 1; i < n; i++) (function (k) { setTimeout(function () { stepOnce(sign); }, k * gap); })(i);
  }
  function step(d) { stepMany(1, d); }
  function updateArrows() {
    if (C.loop) return;
    [prevBtn, nextBtn].forEach(function (b, n) {
      if (!b) return;
      var off = (n === 0 && S.active <= 0) || (n === 1 && S.active >= S.N - 1);
      b.setAttribute('aria-disabled', off ? 'true' : 'false'); b.style.opacity = off ? '.4' : '';
    });
  }
  function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
  function restartAuto() {
    stopAuto();
    if (!C.auto || reduced() || S.N < 2) return;
    autoTimer = setInterval(function () { if (alive() && !document.hidden && !K.active) stepOnce(1); }, C.autoMs || 5000);
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
  floor.setAttribute('tabindex', '0');
  floor.addEventListener('keydown', function (e) {
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); } else if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
  });
  track.addEventListener('click', function (e) {
    if (dragMoved) return;
    var el = e.target.closest ? e.target.closest('.isdst__slot') : null;
    if (!el || Math.abs(el.__x) > S.m) return;
    if (el.__x === 0) { var p = cur(); if (p) window.location.href = p.u; return; }
    stepMany(Math.abs(el.__x), el.__x < 0 ? -1 : 1);
  });

  // ---- drag / swipe (pointer events; vertical page scroll stays native through touch-action: pan-y)
  var drag = null;
  function onDown(e) {
    if (!C.swipe || S.N < 2) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (e.target.closest && e.target.closest('button, a, input, select')) return;
    drag = { x: e.clientX, y: e.clientY, dx: 0, axis: null };
    dragMoved = false; stopAuto();
  }
  function onMove(e) {
    if (!drag) return;
    var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (!drag.axis) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (drag.axis === 'x') floor.classList.add('is-dragging');
    }
    if (drag.axis !== 'x') return;
    drag.dx = dx; dragMoved = true;
    placeAll(dx);
  }
  function onUp() {
    if (!drag) return;
    var dx = drag.dx, axis = drag.axis;
    floor.classList.remove('is-dragging');
    drag = null;
    if (axis === 'x') {
      var th = Math.min(C.thr || 50, floor.clientWidth * 0.12);
      if (dx <= -th) step(1); else if (dx >= th) step(-1); else placeAll(0);
    }
    restartAuto();
    setTimeout(function () { dragMoved = false; }, 0);
  }
  if (window.PointerEvent) {
    floor.addEventListener('pointerdown', onDown);
    on(window, 'pointermove', onMove);
    on(window, 'pointerup', onUp);
    on(window, 'pointercancel', onUp);
  } else {
    floor.addEventListener('touchstart', function (e) { onDown(e.touches[0]); }, { passive: true });
    floor.addEventListener('touchmove', function (e) { onMove(e.touches[0]); }, { passive: true });
    floor.addEventListener('touchend', onUp);
  }

  // ------------------------------------------------------------------ purchase form
  // The form is replaced from time to time (freshForm), so its listeners are delegated from the permanent controls wrapper.
  if (controls) {
    controls.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-qty-down],[data-qty-up]') : null;
      if (!t || !form || !form.contains(t)) return;
      setQty(qty + (t.hasAttribute('data-qty-up') ? 1 : -1));
    });
    controls.addEventListener('change', function (e) {
      if (!varSel || e.target !== varSel) return;
      var p = cur(); if (!p) return;
      variantIdx = parseInt(varSel.value, 10) || 0;
      paintPrice(p); paintBuy(p);
    });
    // capture phase: runs before any listener the offer widget put on the form itself (as the form's own listener did before)
    controls.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f !== form) return;
      e.preventDefault();
      onSubmit();
    }, true);
  }
  function resetBtn() { if (!addBtn) return; addBtn.classList.remove('is-added', 'is-error'); var p = cur(); if (p) paintBuy(p); }
  // The offer widget writes its selection into the form as a hidden input (properties[__kaching_bundles]); a native form post
  // would carry it, so the cart request carries it too. Without it the app can only guess the offer from the last click, and
  // because it keeps every earlier mount of the same offer, it can then apply the bar of an OLDER mount instead of the one
  // the shopper sees. With it, the request names its own bar and Kaching merges exactly that one.
  function lineProps() {
    var out = null;
    if (!form) return out;
    [].forEach.call(form.querySelectorAll('input[name^="properties["]'), function (el) {
      var m = /^properties\[(.+)\]$/.exec(el.name);
      if (m && el.value) { out = out || {}; out[m[1]] = el.value; }
    });
    return out;
  }
  function onSubmit() {
    var p = cur(); if (!p || adding || S.want >= 0) return;
    if (C.cta === 'product') { window.location.href = p.u; return; }
    var vid = idInput ? idInput.value : '';
    if (!vid || vid === '0') return;
    if (!window.ISD || !window.ISD.cart) { form.removeAttribute('data-isd-native'); form.submit(); return; }
    adding = true;
    if (msgEl) msgEl.textContent = '';
    addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true'); addLabel.textContent = L.adding;
    var line = { id: Number(vid), quantity: qty }, lp = lineProps();
    if (lp) line.properties = lp;
    window.ISD.cart.add({ items: [line] }).then(function () {
      adding = false;
      addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); addBtn.classList.add('is-added');
      addLabel.textContent = '✓ ' + L.added;
      setLive((L.liveAdded || '').replace('%title%', p.t));
      if (window.ISD.cart.open) window.ISD.cart.open();
      setTimeout(resetBtn, 1800);
    }).catch(function (err) {
      adding = false;
      addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); addBtn.classList.add('is-error');
      addLabel.textContent = L.add;
      if (msgEl) msgEl.textContent = (err && err.status === 422 && err.message) ? err.message : L.error;
      setTimeout(resetBtn, 2200);
    });
  }

  // ------------------------------------------------------------------ pills
  var navMoved = false;
  function vis() { return M.filter(function (t) { return !t.hidden; }); }
  function neighbour(T) {
    var list = vis(), k;
    for (k = 0; k < list.length; k++) if (list[k].i > T.i) return list[k];
    for (k = list.length - 1; k >= 0; k--) if (list[k].i < T.i) return list[k];
    return null;
  }
  function updateMore() {
    if (!nav || !navWrap) return;
    navWrap.classList.toggle('has-more-l', nav.scrollLeft > 2);
    navWrap.classList.toggle('has-more-r', nav.scrollLeft + nav.clientWidth < nav.scrollWidth - 2);
  }
  // Keep the active pill in view, centred whenever the row can scroll that far; instant = no animation (first paint, resize).
  // The position comes from the rectangles (the pills sit in a centred list inside the scroller, not directly in it).
  function centerTab(btn, instant) {
    if (!nav || !btn) return;
    var max = nav.scrollWidth - nav.clientWidth;
    if (max > 2) {
      var nb = nav.getBoundingClientRect(), bb = btn.getBoundingClientRect();
      var left = nav.scrollLeft + (bb.left - nb.left) - (nav.clientWidth - bb.width) / 2;
      left = Math.max(0, Math.min(max, left));
      if (instant || reduced()) nav.scrollLeft = left;
      else { try { nav.scrollTo({ left: left, behavior: 'smooth' }); } catch (e) { nav.scrollLeft = left; } }
    }
    updateMore();
  }
  // the two small scroll buttons (CSS shows them on mouse devices, and only on the side that still has pills)
  [].forEach.call(navWrap ? navWrap.querySelectorAll('[data-navbtn]') : [], function (b) {
    b.addEventListener('click', function () {
      var d = Number(b.getAttribute('data-navbtn')) < 0 ? -1 : 1, by = d * Math.max(120, Math.round(nav.clientWidth * 0.72));
      try { nav.scrollBy({ left: by, behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { nav.scrollLeft += by; }
    });
  });
  function shownTab() { var i = S.want >= 0 ? S.want : S.tab; return M[i] || null; }
  function centerActive() { var T = shownTab(); if (T && !T.hidden) centerTab(T.el, true); }
  function setTabUI(i) {
    M.forEach(function (t, k) {
      var on = k === i;
      t.el.classList.toggle('is-active', on); t.el.setAttribute('aria-selected', on ? 'true' : 'false'); t.el.tabIndex = on ? 0 : -1;
    });
    if (M[i]) root.setAttribute('aria-labelledby', M[i].el.id);
  }
  function navFix() {
    var n = vis().length;
    if (navWrap) navWrap.hidden = n < 2;
    updateMore(); centerActive();
  }
  function hideTab(T) {
    T.hidden = true; T.el.hidden = true;
    navFix();
  }
  function relabel(T) {
    var txt = T.mode === 'curated' && T.alt ? T.alt : T.label, span = T.el.querySelector('.isdst-tab__txt') || T.el;
    if (span.textContent !== txt) span.textContent = txt;
    T.el.classList.toggle('is-curated', T.mode === 'curated');
  }

  // ---- loading, empty and error states
  var skelTimer = 0;
  function loading(on, token) {
    clearTimeout(skelTimer);
    if (!on) { root.classList.remove('is-loading'); root.removeAttribute('aria-busy'); return; }
    root.setAttribute('aria-busy', 'true');
    skelTimer = setTimeout(function () { if (token === S.token) root.classList.add('is-loading'); }, 150);
  }
  // the purchase module is frozen while another list loads: nothing of the previous list can be added, no stale offer widget stays
  function quiet(on) {
    if (!controls) return;
    controls.classList.toggle('is-busy', on);
    if ('inert' in controls) controls.inert = on; else controls.setAttribute('aria-hidden', on ? 'true' : 'false');
    if (on) kClear();
  }
  function showMessage(text, retryTab) {
    loading(false);
    track.classList.add('is-out');
    root.classList.add('is-empty');
    if (headEl) headEl.hidden = true;
    floor.hidden = true;
    if (controls) controls.hidden = true;
    S.N = 0; S.items = []; S.T = null;
    if (emptyEl) emptyEl.hidden = false;
    if (emptyText) emptyText.textContent = text || '';
    if (retryBtn) retryBtn.hidden = !retryTab;
    S.retry = retryTab ? retryTab.i : -1;
    quiet(false);
  }
  function fail(T) {
    S.want = -1; S.tab = -2;
    root.classList.remove('is-swapping');
    showMessage(L.loadError || '', T);
  }
  function emptyTab(T) {
    S.want = -1;
    if (T.he) {
      hideTab(T);
      var nx = neighbour(T);
      if (nx) { setLive((L.liveHidden || '').replace('%label%', T.label)); select(nx.i, false, true); return; }
    }
    S.tab = T.i;
    showMessage(L.empty || '', null);
  }
  function finish(T, token) {
    loading(false);
    if (!T.out.length) { emptyTab(T); return; }
    relabel(T);
    root.classList.remove('is-empty');
    track.classList.add('is-build');
    build(T, 0);
    if (!S.boot) announceTab(T);
    S.want = -1;
    quiet(false);
    whenImages(S.els, 900).then(function () {
      if (token !== S.token || dead) return;
      void track.offsetWidth;
      track.classList.remove('is-build');
      track.classList.remove('is-out');
      // from now on the floor height may animate (it must not animate the very first --floor-h write)
      if (!root.classList.contains('is-ready')) { void floor.offsetHeight; root.classList.add('is-ready'); }
    });
    warmNext();
  }
  function select(i, focus, boot) {
    var T = M[i];
    if (!T || T.hidden) return;
    // compare with the PENDING pill too (S.tab only changes inside finish(), after the data arrived), so clicking back to the
    // pill that is still shown during the switch is honoured
    var shown = S.want >= 0 ? S.want : S.tab;
    if (i === shown && !boot) return;
    S.want = i;
    S.boot = !!boot;
    setTabUI(i);
    centerTab(T.el, !!boot);
    if (focus) T.el.focus({ preventScroll: true });
    var token = ++S.token;
    stopAuto();
    clearTimeout(growTimer);
    quiet(true);
    if (emptyEl) emptyEl.hidden = true;
    if (root.classList.contains('is-empty')) { // an earlier message collapsed the stage: bring the (frozen) frame back for the skeleton
      root.classList.remove('is-empty');
      if (headEl) headEl.hidden = false;
      floor.hidden = false;
      if (controls) controls.hidden = false;
    }
    var fade = !(reduced() || boot);
    if (fade) { track.classList.add('is-out'); root.classList.add('is-swapping'); }
    loading(true, token);
    var t0 = Date.now();
    F.load(T).then(function () {
      var rest = fade ? Math.max(0, 190 - (Date.now() - t0)) : 0;
      setTimeout(function () { if (token === S.token && !dead) finish(T, token); }, rest);
    }, function () { if (token === S.token && !dead) fail(T); });
  }
  // the next pill is loaded in the background once the first one is on screen (one small request, never on "save data")
  var warmedNext = false;
  function warmNext() {
    if (warmedNext || (navigator.connection && navigator.connection.saveData)) return;
    warmedNext = true;
    var go = function () { if (dead || !S.T) return; var nx = neighbour(S.T); if (nx && nx.i > S.T.i) F.prime(nx); };
    setTimeout(function () { if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(go, { timeout: 3000 }); else go(); }, 1200);
  }
  var primeT = 0;
  function primeSoon(T) {
    if (T.loaded || T.p || T.hidden) return;
    clearTimeout(primeT);
    primeT = setTimeout(function () { if (!dead) F.prime(T); }, 120);
  }

  M.forEach(function (T, i) {
    var t = T.el;
    t.addEventListener('click', function () { if (!navMoved) select(i, false); });
    t.addEventListener('pointerenter', function () { primeSoon(T); });
    t.addEventListener('focus', function () { primeSoon(T); });
    t.addEventListener('touchstart', function () { primeSoon(T); }, { passive: true });
    t.addEventListener('keydown', function (e) {
      var list = vis(), n = list.length, p = list.indexOf(T), k = -1;
      if (p < 0) return;
      if (e.key === 'ArrowRight') k = (p + 1) % n; else if (e.key === 'ArrowLeft') k = (p - 1 + n) % n;
      else if (e.key === 'Home') k = 0; else if (e.key === 'End') k = n - 1;
      if (k >= 0) { e.preventDefault(); select(list[k].i, true); }
    });
  });
  if (retryBtn) retryBtn.addEventListener('click', function () { if (S.retry >= 0) select(S.retry, false, true); });
  if (nav) {
    nav.addEventListener('scroll', updateMore, { passive: true });
    // mouse users have no scrollbar: drag the row
    var nd = null;
    nav.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || nav.scrollWidth <= nav.clientWidth + 2) return;
      nd = { x: e.clientX, left: nav.scrollLeft }; navMoved = false;
    });
    on(window, 'pointermove', function (e) {
      if (!nd) return;
      var dx = e.clientX - nd.x;
      if (!navMoved && Math.abs(dx) > 5) { navMoved = true; nav.classList.add('is-dragging'); }
      if (navMoved) nav.scrollLeft = nd.left - dx;
    });
    on(window, 'pointerup', function () {
      if (!nd) return; nd = null; nav.classList.remove('is-dragging');
      setTimeout(function () { navMoved = false; }, 0);
    });
  }

  // ------------------------------------------------------------------ resize
  var rt = null;
  on(window, 'resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      if (!alive()) return;
      var w = window.innerWidth, b = bp();
      // only a real width change re-centres the pill: a phone's collapsing address bar fires height-only resizes
      if (w !== lastW || b !== lastBp) centerActive();
      updateMore();
      reserveText();
      if (!S.T || !S.N) return;
      if (w === lastW && b === lastBp) return;
      lastW = w; lastBp = b;
      track.classList.add('is-build');
      var keep = S.active;
      build(S.T, keep);
      void track.offsetWidth;
      track.classList.remove('is-build');
    }, 120);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (alive()) { reserveText(true); centerActive(); updateMore(); } });

  // Theme Editor: the section is re-rendered, so release everything this instance holds
  function teardown() {
    if (dead) return;
    dead = true;
    stopAuto(); clearTimeout(swapTimer); clearTimeout(rt); clearTimeout(growTimer); clearTimeout(skelTimer); clearTimeout(primeT);
    kClear();
    if (ac) ac.abort();
    root.__isdst = false;
  }
  on(document, 'shopify:section:unload', function (e) { if (e.target && e.target.contains && e.target.contains(root)) teardown(); });
  // selecting a "Kategorijos žyma" block in the Theme Editor opens that category in the preview
  on(document, 'shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.contains) return;
    for (var k = 0; k < M.length; k++) {
      if (M[k].el === el || el.contains(M[k].el)) { if (M[k].hidden) { M[k].hidden = false; M[k].el.hidden = false; navFix(); } select(k, false); return; }
    }
  });

  // ------------------------------------------------------------------ boot
  reserveText();
  var firstT = vis()[0];
  if (!firstT) return;
  navFix();
  select(firstT.i, false, true);
  if (nav) nav.classList.add('is-ready');

  window.ISD = window.ISD || {};
  window.ISD.stage = { cfg: C, state: S, feed: F, tabs: M, select: select, step: step, centerActive: centerActive, rebuild: function () { if (S.T) { build(S.T, S.active); placeAll(0); } }, geometry: geometry };
})();
